import styled, { css } from 'styled-components';

const Padding = styled.div`
  ${({ $padding }) => $padding === 'small' && css`
    padding: 1rem 0;
  `}
  ${({ $padding }) => $padding === 'normal' && css`
    padding: 3rem 0;
  `}
  ${({ $padding }) => $padding === 'large' && css`
    padding: 5rem 0;
  `}
  ${({ $padding }) => $padding === 'extreme' && css`
    padding: 12rem 0;
  `}
  ${({ $padding }) => $padding === 'extreme_top_normal_bottom' && css`
    padding: 9rem 0 3rem 0;
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      padding: 12rem 0 3rem 0;
    }
  `}
`;

export default Padding;
